module.exports = __webpack_public_path__ + "media/images/battery_red-848347b18e952204f3776fa3694e166a.png";